import React, { useState, useEffect } from 'react';
import { useTranslation, Trans } from 'react-i18next';

import { Cookie } from '@/tscapi/utils/cookie';

import { useAuthenticated } from './hooks/useAuthenticated';
import { useCart, useRemoveDonation } from './hooks/useCart';
import { useOrderReview } from './hooks/useOrderReview';
import { en, fr } from './i18n';

interface EasyPayModifyProps {
    isModifyOrder: boolean;
}

export function EasyPayModify({ isModifyOrder }: EasyPayModifyProps) {
    const cookie: Cookie = new Cookie();
    const { i18n, t } = useTranslation('shoppingbag');
    i18n.addResourceBundle('en', 'shoppingbag', en, true, true);
    i18n.addResourceBundle('fr', 'shoppingbag', fr, true, true);
    const isAuthenticated = useAuthenticated();
    const { data, isLoading } = useCart(isAuthenticated);
    const { data: orderReviewData, isFetching } = useOrderReview(isAuthenticated, cookie.ModifyOrderNumber, data);

    return (
        <>
            {orderReviewData?.EasyPay != null && (
                <>
                    <div className="summary__row">
                        <div className="summary__label--wide">{t('Number of installments')}</div>
                        <div className="summary__value">{orderReviewData?.EasyPay?.NoOfInstallments}</div>
                    </div>
                    <div className="summary__row">
                        <div className="summary__label--wide">
                            <span className="summary__easypay--today">{t('Your total payment today')}</span>
                        </div>
                        <div className="summary__value">
                            <span className="summary__easypay--today">
                                {orderReviewData?.EasyPay?.TotalPaymentToday}
                            </span>
                        </div>
                    </div>

                    <div className="summary__row">
                        <div className="summary__label--wide">
                            <span>{t('Payment amount left after today')}</span>
                        </div>
                        <div className="summary__value">
                            <span>{orderReviewData?.EasyPay?.BalanceRemainingAfterToday}</span>
                        </div>
                    </div>

                    <div className="summary__row">
                        <div className="summary__label--wide">
                            <span>{orderReviewData?.EasyPay?.NoOfFutureMonthlyPayments}</span>{' '}
                            <span>{t('future monthly payments')}</span>
                        </div>
                        <div className="summary__value">
                            <span>{orderReviewData?.EasyPay?.FutureMonthlyPayment}</span>
                        </div>
                    </div>
                </>
            )}
        </>
    );
}
